module.exports = __webpack_public_path__ + "assets/f2e5a5e71b73eabc2488cb7dc63b3d80.png";